// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { List, Divider, Button } from 'semantic-ui-react'

export default class PricingTable extends Component {
  render () {
    return (
      <div className='pricing-card mb center'>
        <h1>$35/m</h1>
        <h5>
          *<b>Billed monthly</b>
        </h5>
        <Divider />
        <List>
          <List.Item>For iOS & Android</List.Item>
          <List.Item>Unlimited screens</List.Item>
          <List.Item>Unlimited components</List.Item>
          <List.Item>Google Sheets integration</List.Item>
          <List.Item>WooCommerce integration</List.Item>
          <List.Item>WordPress integration</List.Item>
          <List.Item>No additional branding</List.Item>
          <List.Item>Email support</List.Item>
        </List>
        <Divider />
        <Divider hidden />

        <Button fluid
          href='https://buy.paddle.com/product/579468'
          target='_blank'
          rel='noopener noreferrer'
          size='large'
          color='black'>
          Checkout
        </Button>
      </div>
    )
  }
}
